module.exports = __webpack_public_path__ + "img/BOTTLE_TECATE.526ad533.png";